import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Home, ArrowLeft, Search } from 'lucide-react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Helmet>
        <title>Seite nicht gefunden | unternehmenbewerten.ch</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      
      <Header />
      
      <main className="flex-1 flex items-center justify-center pt-20 pb-16 px-4">
        <div className="text-center max-w-lg">
          {/* 404 Number */}
          <div className="relative mb-8">
            <span className="text-[180px] font-black text-gray-100 leading-none select-none">
              404
            </span>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-24 h-24 rounded-full bg-[#FFE5E5] flex items-center justify-center">
                <Search className="w-12 h-12 text-[#FF0000]" />
              </div>
            </div>
          </div>
          
          {/* Message */}
          <h1 className="text-3xl font-bold text-[#1a1c1b] mb-4">
            Seite nicht gefunden
          </h1>
          <p className="text-gray-500 mb-8 text-lg">
            Die gesuchte Seite existiert leider nicht oder wurde verschoben.
            Nutzen Sie unsere Navigation oder starten Sie eine Unternehmensbewertung.
          </p>
          
          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/" 
              className="btn-primary gap-2"
              data-testid="404-home-btn"
            >
              <Home size={18} />
              Zur Startseite
            </Link>
            <Link 
              to="/bewertung" 
              className="btn-secondary gap-2"
              data-testid="404-bewertung-btn"
            >
              Bewertung starten
            </Link>
          </div>
          
          {/* Quick Links */}
          <div className="mt-12 pt-8 border-t border-gray-200">
            <p className="text-sm text-gray-400 mb-4">Beliebte Seiten</p>
            <div className="flex flex-wrap justify-center gap-4 text-sm">
              <Link to="/unternehmensbewertung" className="text-[#FF0000] hover:underline">
                Unternehmensbewertung
              </Link>
              <Link to="/unternehmen-verkaufen" className="text-[#FF0000] hover:underline">
                Firma verkaufen
              </Link>
              <Link to="/blog" className="text-[#FF0000] hover:underline">
                Blog & Ratgeber
              </Link>
              <Link to="/kontakt" className="text-[#FF0000] hover:underline">
                Kontakt
              </Link>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default NotFoundPage;
